<template>
    <div ref="selectDepartCardDom" :class="initFlag === true ? 'full-width' : 'full-width-wait'">
        <el-row :gutter="15">
            <el-col :span="cols" v-for="(v, i) in cardList" :key="v.id" style="margin-bottom: 15px">
                <departCard :cardObj="v" :cardIndex="i" />
            </el-col>
        </el-row>
    </div>
</template>

<script setup>
    import {getCurrentInstance, onMounted, ref, computed} from 'vue'
    import departCard from "@/components/shopopee/company/departCard"

    const props = defineProps(['cardList'])
    const emits = defineEmits(['clickCardBtn'])

    const refWidth = ref(425)
    const initFlag = ref(false)

    const { proxy } = getCurrentInstance()

    const cols = computed(() => {
        const colWidth = refWidth.value

        if (colWidth < 800) {
            return 24
        }

        if (colWidth < 1200){
            return 12
        }

        return 8
    })

    onMounted(() => {
        setTimeout(() => {
            refWidth.value = proxy.$refs.selectDepartCardDom.offsetWidth
            initFlag.value = true
        }, 350)
    })
</script>

<style scoped>
    .full-width {
        width: 100%;
    }

    .full-width-wait {
        width: 100%;
        opacity: 0;
    }
</style>